<template>
    <div class="informations-container" :class="{ 'two-lines': twoLines }">
        <div class="breadcrumb" v-if="showBreadcrumb">
            <a href="/">{{ $t("faq.breadcrumb_title") }}</a>
            >
            <span class="active">{{ breadcrumbText }}</span>
        </div>
        <img class="background" src="../../../images/bigTitleLogoR.svg" loading="lazy" />
        <h1 class="title" v-html="title" />
        <div class="subtitle">
            {{ description }}
        </div>
        <div class="text" v-html="text" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        showBreadcrumb: {
            type: Boolean,
            default: false,
        },
        breadcrumbText: {
            type: String,
            default: "",
        },
        twoLines: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>



.informations-container {
    align-items: center;
    background: $black;
    color: white;
    display: flex;
    flex-direction: column;
    padding: 8rem 1.6rem;
    position: relative;

    @include teq-breakpoint($large) {
        padding: 15.1rem 0 15.7rem 0;
    }

    &.two-lines {
        @include teq-breakpoint($large) {
            padding: 10.7rem 0 13.1rem 0;
        }

        .subtitle {
            margin-bottom: 1.6rem;
        }
    }

    .background {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
    }

    .breadcrumb {
        font-family: $f-nouvelR-regular;
        font-size: 16px;
        left: 8.8rem;
        letter-spacing: 0.015em;
        line-height: 16px;
        position: absolute;
        top: 1.6rem;
        z-index: 2;

        a {
            color: #fff;
        }

        .active {
            color: $primary;
            font-family: $f-nouvelR-bold;
        }
    }

    .title {
        margin: 0;
        text-align: center;
    }

    .subtitle {
        font-family: $f-nouvelR-semibold;
        font-size: 16px;
        line-height: 18px;
        margin-top: 1rem;
        text-align: center;

        @include teq-breakpoint($large) {
            padding: 0 37rem;
        }
    }

    .text {
        font-family: $f-nouvelR-regular;
        font-size: 20px;
        line-height: 110%;
        margin-top: 2.4rem;
        text-align: center;

        @include teq-breakpoint($large) {
            margin-top: 4rem;
        }
    }

    .link {
        color: #fff;
        text-decoration: underline;

        &:active,
        &:hover,
        &:visited {
            color: #fff;
        }
    }
}
</style>